import React, { useState, createContext, useContext, useEffect, useCallback } from 'react';

export const AuthContext = createContext({
    isLoggedIn: false,
    user: null,
    login: () => {},
    logout: () => {},
    refreshProfile: async () => {},
    setUser: () => {}
  });

  export const useAuth = () => useContext(AuthContext);

  export const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    // 세션이 유효할 때 프로필 전체 정보 로드
    const fetchProfile = useCallback(async (baseUser) => {
      try {
        const res = await fetch('/api/profile', {
          method: 'GET',
          credentials: 'include'
        });
        if (res.ok) {
          const profile = await res.json();
          const merged = { ...baseUser, ...profile };
          setUser(merged);
          sessionStorage.setItem('user', JSON.stringify(merged));
          return merged;
        }
      } catch (e) {
        console.error('프로필 조회 오류:', e);
      }
      return baseUser;
    }, []);

    // 앱 시작 시 서버 세션 확인
    useEffect(() => {
      const checkSession = async () => {
      try {
        const response = await fetch('/api/session', { credentials: 'include' });
        const data = response.ok ? await response.json() : {};
        if (!data.userId) throw new Error('No verified session');
        const userData = { id: data.userId, name: data.userName, ssoUserId: data.ssoUserId };
        setIsLoggedIn(true); setUser(userData); sessionStorage.setItem('user', JSON.stringify(userData));
        await fetchProfile(userData);
      } catch (_) {
        sessionStorage.removeItem('user'); localStorage.removeItem('user');
        setIsLoggedIn(false); setUser(null);
      } finally { setIsLoading(false); }
    };
    checkSession();
    }, [fetchProfile]);

    const login = (userData) => {
      sessionStorage.setItem('user', JSON.stringify(userData));
      setIsLoggedIn(true);
      setUser(userData);
      // 로그인 직후 전체 프로필 동기화
      fetchProfile(userData);
    };

    const logout = async () => {
      try {
        await fetch('/api/logout', { method: 'GET', credentials: 'include' });
      } catch (e) {
        console.error('로그아웃 요청 오류:', e);
      }
      sessionStorage.removeItem('user');
      setIsLoggedIn(false);
      setUser(null);
    };

    const refreshProfile = useCallback(async () => {
      if (!user) return null;
      return fetchProfile(user);
    }, [user, fetchProfile]);

    if (isLoading) {
      return <div>Loading...</div>;
    }

    return (
      <AuthContext.Provider value={{ isLoggedIn, user, login, logout, refreshProfile, setUser }}>
        {children}
      </AuthContext.Provider>
    );
  };
